import { render, staticRenderFns } from "./wallet-list.vue?vue&type=template&id=e6e0a8e6&scoped=true"
import script from "./wallet-list.vue?vue&type=script&lang=js"
export * from "./wallet-list.vue?vue&type=script&lang=js"
import style0 from "./wallet-list.vue?vue&type=style&index=0&id=e6e0a8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e0a8e6",
  null
  
)

export default component.exports